import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { DomainAuthService } from 'src/app/private/services/domainauth.service';
import { AddAuthDomainComponent } from "../../components/domain-authentication/add-auth-domain/add-auth-domain.component";
import { MessageService } from 'primeng/api';
import { DeleteDomainComponent } from "../../components/domain-authentication/delete-domain/delete-domain.component";

@Component({
  selector: 'app-domain-authentication',
  imports: [ToolBarComponent, SharedModule, AddAuthDomainComponent, DeleteDomainComponent],
  templateUrl: './domain-authentication.component.html',
  styleUrl: './domain-authentication.component.scss'
})
export class DomainAuthenticationComponent {

  totalRecords: number = 0;
  rows: number = 50; // Default page size
  pageSizeOptions = [10, 20, 50]; // Page size options for dropdown
  loading: boolean = false;
  domainData: any[] = []; // Initialize domainData as an empty array

  isAddDomain: boolean = false;
  isShowEditDetails: boolean = false;
  openDeleteDialog: boolean = false;

  domainActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'View',
          icon: 'pi pi-fw pi-eye',
          command: () => {
            this.isShowEditDetails = true;
            this.isAddDomain = true;
          }
        },
        {
          label: 'Add Email',
          icon: 'pi pi-envelope',
          command: () => {
           this.showAddEmailDialog();
          }
        },
        {
          label : 'Refresh',
          icon: 'pi pi-fw pi-refresh',
          command: () => {
            this.onRefresh();
          }
        },
        {
          label: 'Delete',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
              this.openDeleteDialog = true;
          }
        }
      ]
    }
  ]

  domainDataToEdit: any;

  constructor(private api: DomainAuthService, private localStorage: LocalStorageService, private messageService: MessageService) { }

  ngOnInit() {
    this.loadData();
  }

  loadData(msg?: any) {
    this.loading = true;

    const body: any = {
      "organization_id": this.localStorage.getOrganizationId(),
    }

    this.api.getAllClientDomain(body).subscribe({
      next: (data) => {
        this.domainData = data || []
        this.totalRecords = this.domainData.length;
        this.loading = false;

        if (msg === 'verify') {
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Domain verification status updated successfully.' });
        }

      },
      error: () => {
        this.loading = false;
      },
    });
  }

  onRefresh() {
  
    const body = {
      "organization_id": this.localStorage.getOrganizationId(),
      "domain": this.domainDataToEdit.domain
    }
    this.loading = true;
    this.api.domainVerificationStatus(body).subscribe({
      next: () => {
        this.loadData('verify');
      },
      error: (e) => {
        console.log('Error refreshing domain verification status:', e);
        // if status code is 400, show error message
        if (e.status === 404) {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Domain not found' });
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Error refreshing domain verification status' });
        }
        this.loading = false;
      }
    });
  }


  handleAddDomainAuth() {
    this.isAddDomain = true;
  }

  setDomainData(rowData: any) {
    this.domainDataToEdit = rowData;
  }

  showAddEmailDialog() {
    // Logic to show the add email dialog
    if(this.domainDataToEdit.status === 'Success') {
      // Show the add email dialog
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Domain is not verified, please verify the domain before adding emails.' });
    }
  }

}
